<template>
    <div class="wrapper">
        <transition name="router-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="1000">
            <HeroCaro ref="HeroCaro" v-bind:Title="currentTitle" v-bind:Tagline="currentTagline"/>
        </transition>
        <IntroCaro />
        <!-- <Content @changeNavText="changeNavText($event)" @contentListener="contentListener($event)" /> -->
        <transition name="router-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="1000">
            <component v-bind:is="currentContent" @changeNavText="changeNavText($event)" @contentListener="contentListener($event)" @changeComponent="changeComponent($event)"></component>
        </transition>
        <!-- <Content /> -->
    </div>
</template>

<script>
import HeroCaro from './HeroCaro.vue';
import IntroCaro from './IntroCaro.vue';
import Content from './Content.vue';
import Content2 from './Content2.vue';
import Content3 from './Content3.vue';

export default {
    name: 'Sim',
    props: ['currentContent'],
    components: {
        'HeroCaro': HeroCaro, 
        IntroCaro, 
        // Content, 
        Content2,
        'Content': Content,
        'Contnet2': Content2,
        'Content3': Content3
    },
    methods: {
        changeNavText($event) {
            // alert(this.sectionName);
            // console.log("RECIEVED");
            // console.log($event);
            this.$emit('changeNavText', $event);
        },
        contentListener($event) {
            // this.$emit('contentListener', $event);
            // console.log($event);
            if ($event == 1) {
                // this.Title = 'Round';
                // this.Tagline = 'A solid earth';
                // this.$refs.HeroCaro.changeTitle('Round', 'A solid earth');
                this.currentTitle = 'Round';
                this.currentTagline = 'A solid earth';
            } else if ($event == 2) {
                // this.Title = 'Flat';
                // this.Tagline = 'A flat earth ';
                // this.$refs.HeroCaro.changeTitle('Flat', 'A flat earth');
                this.currentTitle = 'Flat';
                this.currentTagline = 'A flattened earth';
            } else {
                // this.Title = 'Hollow';
                // this.Tagline = 'A hollow earth';
                // this.$refs.HeroCaro.changeTitle('Hollow', 'A hollow earth');
                this.currentTitle = 'Hollow';
                this.currentTagline = 'A hollow earth';
            }
        },
        changeComponent($event) {
            this.$emit('changeComponent', $event);
        }
    },
    data() {
        return {
            // Title: '',
            // Tagline: '',
            currentTitle: '',
            currentTagline: ''
        }
    }
    
    
}
</script>

<style scoped>
    .wrapper {
        width: calc(100% - 160px);
        margin: auto;
        padding-left: 260px;
        padding-right: 119px;
        box-sizing: border-box;
    }

    /* div {
        height: 100vh;
        width: 100vw;
        background-color: purple;
    } */

</style>